<script setup>
/* global axios */
// Aba Relatórios — KPIs do período (últimos 30 dias por padrão).
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  accountId: { type: [String, Number], required: true },
});
const { t } = useI18n();
const base = `/api/v1/accounts/${props.accountId}/kanban`;
const appointments = ref([]);

const load = async () => {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 30);
  appointments.value =
    (
      await axios.get(`${base}/appointments`, {
        params: { from: from.toISOString(), to: to.toISOString() },
      })
    ).data.data || [];
};
const report = computed(() => {
  const l = appointments.value;
  const total = l.length;
  const by = s => l.filter(a => a.status === s).length;
  const completed = by('completed');
  return {
    total,
    completed,
    missed: by('missed'),
    cancelled: by('cancelled'),
    rate: total ? Math.round((completed / total) * 100) : 0,
  };
});
onMounted(load);
</script>

<template>
  <div class="p-6">
    <p class="mb-4 text-sm text-n-slate-10">
      {{ t('ATENDIMENTOS.reports.last30days') }}
    </p>
    <div class="grid grid-cols-2 gap-4 md:grid-cols-4">
      <div class="p-4 bg-n-solid-2 border border-n-weak rounded-xl">
        <div class="text-2xl font-bold text-n-slate-12">{{ report.total }}</div>
        <div class="text-xs text-n-slate-10 mt-1">
          {{ t('ATENDIMENTOS.reports.counts.total') }}
        </div>
      </div>
      <div class="p-4 bg-n-solid-2 border border-n-weak rounded-xl">
        <div class="text-2xl font-bold text-green-600 dark:text-green-400">
          {{ report.completed }}
        </div>
        <div class="text-xs text-n-slate-10 mt-1">
          {{ t('ATENDIMENTOS.reports.counts.completed') }}
        </div>
      </div>
      <div class="p-4 bg-n-solid-2 border border-n-weak rounded-xl">
        <div class="text-2xl font-bold text-n-ruby-11">{{ report.missed }}</div>
        <div class="text-xs text-n-slate-10 mt-1">
          {{ t('ATENDIMENTOS.reports.counts.missed') }}
        </div>
      </div>
      <div class="p-4 bg-n-solid-2 border border-n-weak rounded-xl">
        <div class="text-2xl font-bold text-n-blue-11">{{ report.rate }}%</div>
        <div class="text-xs text-n-slate-10 mt-1">
          {{ t('ATENDIMENTOS.reports.counts.attendance') }}
        </div>
      </div>
    </div>
  </div>
</template>
